import { getItem, removeItem } from '../../helpers/storage';
import { useHistory } from 'react-router';
import { cleanupFeatureFlagsOnLogout } from '../../helpers/featureFlags/featureFlagIntegrationNew';

export const Logout = () => {
    const history = useHistory();
    
    // Clean up feature flags on logout
    cleanupFeatureFlagsOnLogout();
    
    if (getItem('originalUser')) {
        removeItem('originalUser');
    }
    removeItem('lqaUser');
    removeItem('user');
    history.push('/');
    history.go(0);
    return null;
};
